import { MEDICAL_STATUS_LABELS } from '@/shared/constants';
import type { Status } from '@/entities/user/model/userSchema';

/** Подписи статусов учёта обучения (М7); `warn` совпадает с медицинским справочником. */
export const TRAINING_RECORD_STATUS_LABELS: Record<Status, string> = {
  ok: 'Действует',
  warn: MEDICAL_STATUS_LABELS.warn,
  err: 'Просрочено',
  info: 'Проведён',
};

/** Подписи статусов стажировки; `warn` совпадает с медицинским справочником. */
export const INTERNSHIP_STATUS_LABELS: Record<Status, string> = {
  ok: 'Завершена',
  warn: MEDICAL_STATUS_LABELS.warn,
  err: 'Просрочено',
  info: 'В процессе',
};

export const TRAINING_RECORD_STATUS_FILTER_OPTIONS: {
  value: '' | Status;
  label: string;
}[] = [
  { value: '', label: 'Все статусы' },
  { value: 'ok', label: TRAINING_RECORD_STATUS_LABELS.ok },
  { value: 'warn', label: TRAINING_RECORD_STATUS_LABELS.warn },
  { value: 'err', label: TRAINING_RECORD_STATUS_LABELS.err },
  { value: 'info', label: TRAINING_RECORD_STATUS_LABELS.info },
];

export const TRAINING_TYPE_OPTIONS = [
  { value: '', label: 'Все виды' },
  { value: 'инструктаж', label: 'Инструктаж' },
  { value: 'вводный', label: 'Вводный' },
  { value: 'ОТ', label: 'Обучение по ОТ' },
  { value: 'электро', label: 'Электробезопасность' },
  { value: 'ПТМ', label: 'ПТМ' },
];

/** Виды обучения для формы — единый справочник (US-3.2). */
export const TRAINING_TYPE_FORM_OPTIONS = [
  { value: 'Вводный инструктаж', label: 'Вводный инструктаж' },
  { value: 'Первичный инструктаж', label: 'Первичный инструктаж' },
  { value: 'Повторный инструктаж', label: 'Повторный инструктаж' },
  { value: 'Внеплановый инструктаж', label: 'Внеплановый инструктаж' },
  { value: 'Обучение по ОТ (рабочие)', label: 'Обучение по ОТ (рабочие)' },
  { value: 'Обучение по ОТ (руководители)', label: 'Обучение по ОТ (руководители)' },
  { value: 'Обучение по электробезопасности', label: 'Обучение по электробезопасности' },
  {
    value: 'Обучение по пожарно-техническому минимуму (ПТМ)',
    label: 'ПТМ / пожарно-технический минимум',
  },
  {
    value: 'Обучение по охране труда (спецпрограмма)',
    label: 'Обучение по охране труда (спецпрограмма)',
  },
  { value: 'Стажировочное обучение', label: 'Стажировочное обучение' },
];
